import InsuranceAddonIcon from '../assets/svg/InsuranceAddonIcon';
import Visa_package_addon_Icon from '../assets/svg/Visa_package_addon';

export const DAY_PLAN_CONSTANTS = {
  DAY_PLAN_TAB: 'Day Plan',
  FLIGHTS_TAB: 'Flights',
  HOTELS_TAB: 'Hotels',
  TRANSFERS_TAB: 'Transfers',
  ACTIVITIES_TAB: 'Activities',
  COMMUTES_TAB: 'Commute',
  MEALS_TAB: 'Meals',
};
export const DAY_PLAN_OMNITURE = {
  DAY_PLAN_TAB: 'day_plan',
  FLIGHTS_TAB: 'flight',
  HOTELS_TAB: 'hotel',
  TRANSFERS_TAB: 'transfer',
  ACTIVITIES_TAB: 'activity',
  COMMUTES_TAB: 'Commute',
  MEALS_TAB: 'meals',
};
export const LOBS_CONSTANTS = {
  FLIGHT: 'FLIGHT',
  HOTEL: 'HOTEL',
  TRANSFER: 'CAR',
  ACTIVITY: 'ACTIVITY',
  ADDON_INCLUSION: 'ADDON_INCLUSION',
  TRANSFERS: 'TRANSFERS',
  SIGHTSEEING: 'SIGHTSEEING',
  VISA: 'VISA',
  AIRPORT_TRANSFER: 'AIRPORT_TRANSFER',
  CAR_ITINERARY: 'CAR_ITINERARY',
  MEAL: 'MEAL',
  MEALS: 'MEALS',
  MEAL_DAY_WISE: 'MEAL_DAY_WISE',
  COMMUTE: 'COMMUTE',
  TRANSFER_OTHER: 'TRANSFER',
};

export const COMMUTE_TYPE = {
  FLIGHT: 'FLIGHT',
  FLIGHT_CAR: 'FLIGHT_CAR',
  CAR: 'CAR',
  NMC: 'NO_MAJOR_COMMUTE',
};

export const COMMUTE_INFO = {
  CAB_NOINFO: 'No Info',
  F_C: 'Flights + Cabs',
  CABS: 'Cabs',
};

export const TRANSPORT_TYPE = {
  FLIGHTS: 'Flights',
};

export const LOB_SPRITE_ICONS = {
  FLIGHT: 'dayPlanFlightIcon',
  CAR: 'dayPlanTransferIcon',
  SIGHTSEEING: 'dayPlanTransferIcon',
  AIRPORT_TRANSFER: 'dayPlanTransferIcon',
  CAR_ITINERARY: 'dayPlanTransferIcon',
  ACTIVITY: 'dayPlanActivityIcon',
  HOTEL: 'dayPlanHotelIcon',
  MEAL: 'dayPlanMealIcon',
  VISA: 'dayPlanVisaIcon',
  INSURANCE: InsuranceAddonIcon,
  VISA_PROTECTION_PLAN: Visa_package_addon_Icon,
};
export const LOB_TEXT = {
  FLIGHT: 'Flight',
  CAR: 'Commute',
  SIGHTSEEING: 'Sight Seeing',
  AIRPORT_TRANSFER: 'Commute',
  CAR_ITINERARY: 'Commute',
  ACTIVITY: 'Activity',
  HOTEL: 'Hotel',
  MEAL: 'Meal',
  VISA: 'Visa',
  COMMUTE: 'Transport Option',
  VISA_PROTECTION_PLAN: 'Visa Protection Plan',
  INSURANCE: 'Insurance',
};
export const ERROR_TEXT = {
  FLIGHT: 'Flight',
  CAR: 'Commute',
  SIGHTSEEING: 'Sight Seeing',
  AIRPORT_TRANSFER: 'Commute',
  CAR_ITINERARY: 'Commute',
  ACTIVITY: 'Activity',
  HOTEL: 'Hotels',
  MEAL: 'Meal',
};
export const MODIFY_PACKAGE_ACTION = {
  TOGGLE: 'TOGGLE',
  CHANGE: 'CHANGE',
  MODIFY: 'MODIFY',
  SPLIT: 'SPLIT',
};

export const CHANGE_LOG_TYPE = {
  REMOVE: 'REMOVE',
  ADD: 'ADD',
  CHANGE: 'CHANGE',
  SPLIT: 'SPLIT',
};
export const CHANGE_LOG_TYPE_TEXT = {
  REMOVE: 'Removed',
  ADD: 'Added',
  CHANGE: 'Changed',
  SPLIT: 'Split',
};

export const MEAL_NAMES = {
  BREAKFAST: 'Breakfast',
  LUNCH: 'Lunch',
  DINNER: 'Dinner',
  NO_MEAL: '',
};

export const HOTEL_SUBUNIT_TYPES = ['BREAKFAST', 'LUNCH', 'DINNER'];
export const AIRPORT_TRANSFER_SUBTYPE = {
  TRANSFER_HTA: 'TRANSFER_HTA',
  TRANSFER_ATH: 'TRANSFER_ATH',
};
export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const SECTIONS = {
  TOP_SECTION: 'TOP_SECTION',
  DAY_PLAN_SECTION: 'DAY_PLAN_SECTION',
};

export const GOOGLE_API_KEY = 'AIzaSyBJU4uwaQoXmdcAE7opwszx1kMpDLQr7_c';
export const GOOGLE_API_KEY_SIGHTSEEN = 'AIzaSyBPpSpSa-n_-SQ9F5Rrz8e0NPb07j1qwjw';

export const MAP_PARAMS = {
  BASE_URL: 'https://maps.googleapis.com/maps/api/staticmap',
  SIZE: '243x155',
  ZOOM: 12,
  SCALE: 2,
  MAP_TYPE: 'roadmap',
  MARKER_SIZE: 'mid',
  MARKER_COLOR: 'blue',
};

export const ADD_ACTIVITY_TEXT = {
  END_OF_DAY: 'End Of Day -',
  NOTHING_PLANNED: 'Nothing Planned -',
};
export const ACTIVITY_CARD_TYPE = {
  ADD_ACTIVITY: 'ADD_ACTIVITY',
  ACTIVITY_CARD: 'ACTIVITY_CARD',
};
export const FEATURE_TYPE = {
  VARIANT: 'VARIANT',
  MEAL: 'MEAL',
  MEAL_DAY_WISE: 'MEAL_DAY_WISE',
  VISA: 'VISA',
  VISA_ASSISTANCE: 'VISA_ASSISTANCE',
  ADDON: 'ADDON',
};

export const VISA_STATUS = {
  NOT_INCLUDED_SELECTED: 'included_not included',
  INCLUDED_SELECTED: 'not included_included',
};

export const DAY_PLAN_TEXT = {
  FLIGHT: 'Flight',
  HOTEL: 'Hotel',
  TRANSFER: 'Transfer',
  ACTIVITY: 'Activity',
  Meal: 'Meal',
};

export const SUMMARY_TYPE = {
  INLINE: 'INLINE',
  TABLE: 'TABLE',
  CITY: 'CITY',
};

export const LOB_ICON_CLASS = {
  HOTEL_MEAL: 'mealBlackIcon',
  HOTEL: 'hotelIcon',
  CAR: 'transferIcon',
  FLIGHT: 'flightIcon',
  ACTIVITY: 'blackActivityIcon',
  SIGHTSEEING: 'dayPlanActivityIcon',
};

export const UNIT_SUB_TYPE = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  CAR_SIGHTSEEING: 'CAR_SIGHTSEEING',
  BREAKFAST: 'BREAKFAST',
  DINNER: 'DINNER',
};

export const CAB_FACILITY_TYPE = {
  LUGGAGE: 'LUGGAGE',
  FIRSTAID: 'FIRSTAID',
  AC: 'AC',
  CARRIER: 'CARRIER',
  SEATER: 'SEATER',
  DEFAULT: 'DEFAULT',
};
export const CAB_FACILITY_ICON_CLASS = {
  LUGGAGE: 'luggageIcon',
  FIRSTAID: 'firstAidIcon',
  AC: 'acIcon',
  CARRIER: 'cabFacilityDefaultIcon',
  SEATER: 'cabSeaterIcon',
  DEFAULT: 'cabFacilityDefaultIcon',
};

export const HE_CONSTANT_TEXT = {
  VARIANT_NOTE:
    'Changing the package type might lead to change in Meal Plan and loss of customization.',
};

export const NOTIFICATION_MESSAGE_TYPE = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};

export const FORWARD_FLOW_ERROR_TYPE = {
  HOTEL: 'HOTEL',
  FLIGHT: 'FLIGHT',
  VISA: 'VISA',
  ACTIVITY: 'ACTIVITY',
};

export const REVIEW_ACTION_TYPE = {
  BOOK: 'BOOK',
  QUOTE: 'QUOTE',
  AGENTSECTION: 'AGENTSECTION',
};

export const HOTEL_OVERLAY_TYPE = {
  DETAIL_PAGE: 'DETAIL_PAGE',
  CHANGE_ROOM: 'CHANGE_ROOM',
};

export const TRANSFER_OVERLAY_TYPE = {
  DETAIL_PAGE: 'DETAIL_PAGE',
};
export const PAYMENT_SCHEDULE_OPTIONS = 'PAYMENT_SCHEDULE_OPTIONS';
export const PART_PAYMENT = 'PART_PAYMENT';
export const CARD_TYPE = {
  PACKAGE: 'Package',
  CONTENT: 'Content',
};

export const POPUP_CARD_TYPE_LISTING = {
  SME: 'SME',
  HE: 'HE',
};
export const REVIEW_FAILURE = 'reviewFailure';
export const DETAIL_PAGE_URL = 'dpu';
export const POPUP_CARD_TYPES = {
  SME: 'smeCard',
  HE: 'heCard',
};

export const INCLUSION_NAME_LENGTH = 24;

export const GROUP_COLLECTION_VIEW_TYPE = {
  HOTELVIEW: 'HOTELVIEW',
  ACTIVITYVIEW: 'ACTIVITYVIEW',
};

export const DEFAULT_ROOM_LISTING = [
  {
    noOfAdults: 2,
    noOfChildrenWOB: 0,
    noOfChildrenWB: 0,
    noOfInfants: 0,
    listOfAgeOfChildrenWB: [],
  },
];

export const FEATURE_CONSTANTS = {
  INCLUDED: 'INCLUDED',
  REMOVE: 'REMOVE',
  APPLY: 'APPLY',
};
export const CHECK_PEEK_API_PARAMS = ['depDate', 'fromCity', 'listingClassId', 'room', 'variantId'];

export const INCLUSION_LOBS_TYPE = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  ACTIVITIES: 'activities',
  TRANSFERS: 'transfers',
  VISA: 'visa',
};

export const PAGE_NAME = {
  DETAILS_V3: 'details_v3',
  REVIEW_V3: 'review_v3',
};
